<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M18.3335 10.3942V4.95085C18.3335 4.50882 18.1579 4.0849 17.8454 3.77233C17.5328 3.45977 17.1089 3.28418 16.6669 3.28418H3.33354C2.89151 3.28418 2.46759 3.45977 2.15503 3.77233C1.84246 4.0849 1.66687 4.50882 1.66687 4.95085V14.9508C1.66687 15.3929 1.84246 15.8168 2.15503 16.1294C2.46759 16.4419 2.89151 16.6175 3.33354 16.6175H10.6602"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M18.3335 5.78418L10.841 10.5567C10.5868 10.7044 10.298 10.7821 10.004 10.7821C9.70992 10.7821 9.42113 10.7044 9.16687 10.5567L1.66687 5.78418"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.75 13.7012L17.9167 17.8678"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.9167 13.7012L13.75 17.8678"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconEnvelopeTimes',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
